import { useSelector } from 'react-redux';
import { Order } from 'src/models';

interface UseOrderListSelectorReturnType {
  orderList: Order[];
  isOrderListLoading: boolean;
  hasOrderListError?: boolean;
  orderListError?: string;
  orderListTotal: number;
}

const EMPTY_ORDERS: Order[] = [];

export const useOrderListSelector = (): UseOrderListSelectorReturnType => {
  const orderList: Order[] | undefined = useSelector((state: any) => state.orders.list?.data?.data);
  const isOrderListLoading = useSelector((state: any) => Boolean(state.orders?.list?.isLoading));
  const hasOrderListFailed: boolean = useSelector((state: any) => state.orders.list?.__failed);
  const orderListError: string = useSelector((state: any) => state.orders.list?.__message);
  const orderListTotal: number = useSelector((state: any) => state.orders.list?.data?.total ?? 0);

  return {
    orderList: Array.isArray(orderList) ? orderList : EMPTY_ORDERS,
    isOrderListLoading,
    hasOrderListError: hasOrderListFailed,
    orderListError,
    orderListTotal,
  };
};
